import { Add, Edit } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useDialog } from "../../common/dialog";
import { PageTitle } from "../../layout/PageTitle";
import { createListStore } from "../../common/listStore";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";
import { useState } from "react";
import { UserDetailDialog } from "./UserDetailDialog";
import { CallCenterProjectDto, UserListItemDto } from "./types";
import { useCallCenters, useLanguages, useTmUserTypes, useUserTypes } from "../../common/enum";
import { useAccountStore, UserTypeId } from "../../common/account";

export function UserListPage() {
    const isAdmin = useAccountStore(p => p.data?.accessTokenDecoded.userTypeId === UserTypeId.Admin);
    const [useUserStore] = useState(() => createListStore<UserListItemDto>({
        path: "users",
        itemsPerPage: 15,
        getId: p => p.id,
        listProps: [
            { column: "userName", label: "User name", width: 120, filter: true },
            { column: "firstName", label: "First name", width: 150, filter: true },
            { column: "lastName", label: "Last name", width: 150, filter: true },
            { column: "userTypeId", label: "Type", width: 150, filter: true, enumStore: isAdmin ? useUserTypes : useTmUserTypes },
            { column: "email", label: "Email", width: 250, filter: true },
            { column: "isActive", label: "Active", width: 80, type: "bool" },
            isAdmin && { column: "callCenterId", label: "Call center", width: 150, filter: true, enumStore: useCallCenters },
            isAdmin && { column: "language", label: "Language", width: 100, enumStore: useLanguages },
        ],
    }));

    const [useCallCenterProjectListStore] = useState(() => createListStore<CallCenterProjectDto>({
        path: "users/callCenterProjects",
    }));

    const users = useUserStore(p => ({ selectedItem: p.selectedItem }));
    const newUserDialog = useDialog((close, dialogProps) => <UserDetailDialog close={close} dialogProps={dialogProps} user={null}
        useUserListStore={useUserStore} useCallCenterProjectListStore={useCallCenterProjectListStore}
        onUserChange={() => { useUserStore.getState().fetch(); }} />, undefined, { usingCustomDialogTag: true });
    const editUserDialog = useDialog((close, dialogProps) => <UserDetailDialog close={close} dialogProps={dialogProps} user={users.selectedItem!}
        useUserListStore={useUserStore} useCallCenterProjectListStore={useCallCenterProjectListStore}
        onUserChange={() => { useUserStore.getState().fetch(); }} />, undefined, { usingCustomDialogTag: true });

    return <>
        {newUserDialog.render()}
        {editUserDialog.render()}
        <PageTitle title="Users" />
        {renderListStore(useUserStore, {
            onDoubleClick: () => {
                editUserDialog.show();
            }, header: listHeaderItems([
                ["edit", () => <Button color="edit" disabled={users.selectedItem == null} title="Edit" onClick={() => editUserDialog.show()}><Edit /></Button>],
                ["add", () => <Button color="add" title="Add" onClick={() => newUserDialog.show()}><Add /></Button>],
            ]),
        })}
    </>;
}
